// Lightweight logger que silencia em produção para evitar leaks de informação.
// Em desenvolvimento mantém os logs para debugging.
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  error: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
  info: (...args) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
};
